<template>
  <div class="animated fadeIn list-of-tranbank">
    <b-card>
      <div slot="header">{{$route.meta.label}}
        <div class="card-header-actions">
         <button class="btn btn-primary mr-1" @click="exportxls()">
              <i class="fa fa-file-excel-o"></i>
              Export
          </button>
          <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-row >
        <b-col md="6" lg="4">
          <b-input-group>
            <b-input-group-prepend>
              <span class="p-2">Edisi (Week Name)</span>
            </b-input-group-prepend>
            <b-form-select
              v-model="model.week_id"
              :plain="true"
              :options="weeks"
            ></b-form-select>
          </b-input-group>
        </b-col>
        <b-col lg="6">
            <b-input-group >
              <b-input-group-prepend><span class="pt-2 mr-2">Tanggal/Edisi</span></b-input-group-prepend>
              <b-form-input v-model="model.tgl1" type="date" :state="!$v.model.tgl1.$error"></b-form-input>
              <b-input-group-prepend><span class="input-group-text">-</span></b-input-group-prepend>
              <b-form-input v-model="model.tgl2" type="date" :state="!$v.model.tgl1.$error"></b-form-input>
              <b-input-group-append>
                <b-button class="btn btn-success ml-2" @click="getData()" > <i class="fa fa-play"></i> Process</b-button>
              </b-input-group-append>
            </b-input-group>
        </b-col>
      </b-row>
      <b-card no-body>
            <b-row v-if="(filterShow=='Hide')">
                <b-col lg="3">
                  <b-input-group size="sm">
                    <b-input-group-prepend><span class="ml-1 pt-1 mr-1" size="sm" >Filter</span></b-input-group-prepend>
                    <b-form-input
                        v-model="filter"
                        type="search"
                        id="filterInput"
                        placeholder="Type to Search"
                        ></b-form-input>
                    <b-input-group-append>
                    <b-button :disabled="!filter" @click="clearFilter">Clear</b-button>
                    </b-input-group-append>
                    </b-input-group>
                </b-col> 
                <b-col lg="6">
                  <b-form-group
                    label="Filter On"
                    label-cols-sm="1"
                    label-size="sm"
                    description="Leave all unchecked to filter on all data"
                    class="mb-0">
                    <b-form-checkbox-group v-model="filterOn" class="mt-1">
                      <b-form-checkbox value="CustCode">Customer Name</b-form-checkbox>
                      <b-form-checkbox value="CustCode">Customer Code</b-form-checkbox>
                    </b-form-checkbox-group>
                  </b-form-group>                
                </b-col>                 
                <b-col lg="3">
                        <b-form-checkbox v-model="filterShow" value="Hide" unchecked-value="Show" switch>
                          <b> {{ filterShow }}</b> Filter
                        </b-form-checkbox>
                </b-col>         
            </b-row>
            <b-table
                class="mb-0"
                ref="table"
                outlined responsive striped hover
                style="font-size:smaller;"
                :items="rptLines"
                :fields="tblFields"
                :current-page="tblLcy.page"
                :per-page="tblLcy.limit"
                :sort-by.sync="tblLcy.sortBy"
                :sort-desc.sync="tblLcy.sortDesc"
                :filter="filter"
                :filterIncludedFields="filterOn"
                @filtered="onFiltered"                
            >
                <template v-slot:thead-top="data">
                    <b-tr>
                    <b-th colspan="3"><span class="sr-only">tanggal,custcode,custname</span></b-th>
                    <b-th variant="primary" colspan=5>KIRIMAN</b-th>
                    <b-th variant="secondary" colspan="5">REVISI</b-th>
                    <b-th variant="danger" colspan="2">RETURN</b-th>
                    <b-th ><span class="sr-only">address</span></b-th>
                    </b-tr>
                </template>
                <template v-slot:cell(tanggal)="data">
                    {{ data.item.tanggal | moment("MMM YYYY") }}
                </template>
                <template v-slot:cell(kirtotal_val)="data">
                    {{ data.item.kirtotal_val | numFormat }}
                </template>
                <template v-slot:cell(revtotal_val)="data">
                    {{ data.item.revtotal_val | numFormat }}
                </template>
                <template v-slot:cell(retkonsi_val)="data">
                    {{ data.item.retkonsi_val | numFormat }}
                </template>

                <template v-slot:cell(netto_val)="data">
                    {{ data.item.netto_val | numFormat }}
                </template>
            </b-table>

            <b-row class="mt-2">
                <b-col cols="4">
                    <div style="font-weight: bold;" class="ml-1">Total Nett Sales : {{uanguser}}
                        <div style="text-align:right; border:1px solid silver; width:200px;height:40px;border-top: 1px solid #000 ;border-bottom: 2px solid #000; background: #e6e6e6; display:inline;" class="pl-2 pt-2 pr-2">
                          {{totalSales | numFormat('0,0.00')}}</div>
                    </div>
                </b-col>
                <b-col cols="8">
                    <b-row >
                      <b-col cols="6" style="text-align:center">
                        <div>
                          Showing {{(tblLcy.page - 1) * tblLcy.limit + 1}}
                          to <span v-if="((tblLcy.page * tblLcy.limit)>tblLcy.total)">{{tblLcy.total}}</span> <span v-else>{{tblLcy.page * tblLcy.limit}}</span>
                          of {{tblLcy.total}} entries,   <span class="ml-3 mr-1">limit per page :</span> 
                          <select  v-model="tblLcy.limit"  style="width:60px;">
                            <option>10</option>
                            <option>15</option>
                            <option>20</option>                            
                            <option>25</option>
                            <option>30</option>                            
                          </select>
                        </div>
                        <b-form-checkbox v-model="filterShow" value="Hide" unchecked-value="Show" switch>
                          <b> {{ filterShow }}</b>  Filter
                        </b-form-checkbox>
                      </b-col>
                      <b-col cols="6">            
                        <b-pagination 
                          align="right"
                          :total-rows="tblLcy.total"
                          :per-page="tblLcy.limit"
                          v-model="tblLcy.page"
                        ></b-pagination>
                      </b-col>
                    </b-row>
                </b-col>
            </b-row>
      </b-card>
  </b-card>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    <b-modal v-model="showReport" size="lg" title="Preview as PDF" ok-only>
        <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>

  </div>
</template>


<script>
import moment from 'moment';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import toastr from "mini-toastr";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import koranreport from "../../apis/koran_report";
toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    model: {
        tgl1: { required },
        tgl2: { required },
    },
  }, 
  data() {
    return {
      isLoading:false,
      showReport:false,
      lkuKoranAreaShow:false,
      reportUrl: null,
      model: {week_id:'', week_name:'',tgl1:'',tgl2:''},
      filterShow:'Show',
      uanguser: this.$store.state.user.matauang,
      weeks:[{value:0, text: 'Sunday/Minggu'}, {value:1, text: 'Monday/Senin'},{value:2, text: 'Tuesday/Selasa'}
      ,{value:3, text: 'Wednesday/Rabu'},{value:4, text: 'Thursday/Kamis'},{value:5, text: 'Friday/Jumat'},{value:6, text: 'Saturday/Sabtu'}],
      rptLines : [],
      totalSales : 0,
      tblLcy: {
        page: 1,
        limit: 15,
        total: 0,
        sortBy: null,
        sortDesc: false,
      },
      tblFields: [
        {
          key: "tanggal",
          label: "Tanggal",
          thStyle: "width:90px"
        },
        {
          key: "CustCode",
          label: "Customer Code",
          thStyle: "width:100px",
          sortable: true
        },
        {
          key: "CustName",
          label: "Customer Name",
          sortable: true
        },
        {
          key: "totpaid",
          label: "Berbayar",
          thStyle: "width:50px",
          thClass: "text-center",
          tdClass: "text-center"
        },
        {
          key: "gratis",
          label: "tdk.Berbayar",
          thStyle: "width:40px",
          thClass: "text-center",
          tdClass: "text-center"
        },
        {
          key: "titipan",
          label: "Titipan",
          thStyle: "width:40px",
          thClass: "text-center",
          tdClass: "text-center"
        },
        {
          key: "totkirim",
          label: "Total",
          thStyle: "width:60px",
          thClass: "text-center",
          tdClass: "text-center"
        },
        {
          key: "kirtotal_val",
          label: "NILAI",
          thStyle: "width:100px",
          thClass: "text-center",
          tdClass: "text-right",
          variant: "primary",
          sortable: true
        },
        {
          key: "revtotpaid",
          label: "Berbayar",
          thStyle: "width:40px",
          thClass: "text-center",
          tdClass: "text-center"
        },
        {
          key: "revgratis",
          label: "tdk.Berbayar",
          thStyle: "width:40px",
          thClass: "text-center",
          tdClass: "text-center"
        },
        {
          key: "revtitipan",
          label: "Titipan",
          thStyle: "width:40px",
          thClass: "text-center",
          tdClass: "text-center"
        },
        {
          key: "revtotal",
          label: "Total",
          thStyle: "width:60px",
          thClass: "text-center",
          tdClass: "text-center"
        },
        {
          key: "revtotal_val",
          label: "NILAI",
          thStyle: "width:100px",
          thClass: "text-center",
          tdClass: "text-right",
          variant: "secondary",
          sortable: true
        },
        {
          key: "retkonsi",
          label: "Konsinyasi",
          thStyle: "width:60px",
          thClass: "text-center",
          tdClass: "text-center"
        },
        {
          key: "retkonsi_val",
          label: "NILAI",
          thStyle: "width:100px",
          thClass: "text-center",
          tdClass: "text-right",
          variant: "danger",
          sortable: true
        },
        {
          key: "netto_val",
          label: "OMSET",
          thStyle: "width:120px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true
        }
      ],      
      filter: null,
      filterOn: [],   
    };
  },
  components: {Loading},
  computed: {
    invalidFilter() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
  },  
  created: async function() {
    if (this.$route.params.tgl1 && this.$route.params.tgl2) {
        this.model.week_id = this.$route.params.weekid;
        this.model.week_name = this.$route.params.weekname;
        this.model.tgl1=this.$route.params.tgl1;
        this.model.tgl2=this.$route.params.tgl2;
        setTimeout(() => {
          this.getData();
        }, 100);
        // setTimeout(() => {
        //     if (this.$route.params.menuname) {
        //       this.filterShow='Hide';
        //       this.filter= this.$route.params.menuname,
        //       this.filterOn= ['menuname'];  
        //     }
        // }, 2000);
    } else {
        const tgl2 = moment(this.$store.state.user.tglaktif, 'YYYY-MM-DD').add(1,'M').subtract(1, 'day');
        this.model.tgl1=this.$store.state.user.tglaktif;
        this.model.tgl2=tgl2.format('YYYY-MM-DD');
    }
  },  
  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.tblLcy.total = filteredItems.length;
      this.tblLcy.page = 1;
      this.totalSales = filteredItems.reduce((a, b) => a + b.netto, 0);
    },     
    clearFilter() {
          this.filterOn= []   
          this.filter= '';   
    } ,
    getData: async function(ctx) {
        if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
       } else {
        try {
          this.isLoading=true;
          const result = await koranreport.omsetedisilist(this.model);
          this.rptLines =  result[0];
          this.tblLcy.total = this.rptLines.length;        
          this.grouptotal = result[1]; 
          this.totalSales = this.grouptotal.reduce((a, b) => a + b.totalsales, 0);
          this.isLoading=false;     
        } catch (error) {
                this.isLoading=false;
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }  
        }
      }
       
    },
    exportxls: async function() {
      if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
      } else {
        this.isLoading=true;
        try {
            const response = await koranreport.omsetedisilistexport(this.model);
            this.isLoading=false;    
        } catch (error) {
                this.isLoading=false;
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }  
        }
      }
    },    
    close(){
      router.push({name: "koran.home"});
    }
  }
};
</script>
